<template>
  <div class="fin-panel-body">
    <span class="ui-chip" :class="tone">{{ statusText }}</span>
    <dl class="fin-kv">
      <dt>{{ $t("finance_order") }}</dt>
      <dd>
        <button type="button" class="ui-link" @click="openOrder">#{{ refund.orderId }}</button>
        <template v-if="refund.orderRef"> · {{ refund.orderRef }}</template>
      </dd>
      <dt>{{ $t("finance_customer") }}</dt><dd>{{ refund.customer || "—" }}</dd>
      <dt>{{ $t("finance_amount") }}</dt><dd class="fin-num"><b>{{ money(refund.amount) }}</b></dd>
      <dt>{{ $t("finance_reason") }}</dt><dd>{{ refund.reason || "—" }}</dd>
      <template v-if="refund.method"><dt>{{ $t("finance_payment_method_label") }}</dt><dd>{{ methodText }}</dd></template>
      <template v-if="refund.comment"><dt>{{ $t("finance_shell.settle.note") }}</dt><dd>{{ refund.comment }}</dd></template>
      <template v-if="refund.approvedBy"><dt>{{ $t("finance_shell.refund.approved_by") }}</dt><dd>{{ translate(refund.approvedBy) }}</dd></template>
    </dl>
    <div v-if="error" class="ui-banner ui-banner--info fin-note--bad" role="alert"><v-icon size="16" color="currentColor">mdi-alert-circle-outline</v-icon><span>{{ error }}</span></div>
    <button v-if="canApprove" type="button" class="ui-btn ui-btn--primary ui-btn--block" :disabled="saving" @click="approve">{{ $t("finance_shell.refund.approve") }}</button>
    <small v-else-if="refund.status === 'pending'" class="ui-muted">{{ $t("finance_shell.order.pending_note") }}</small>
  </div>
</template>

<script>
import restaurantFinanceService from "@/services/restaurantFinance";
import { REFUND_STATUS_META, formatMoney } from "@/components/restaurant/finance/constants";
import OrderPanel from "./OrderPanel.vue";

const TONES = { pending: "ui-chip--warn", approved: "ui-chip--ok", rejected: "" };

/** Zahtjev za refundaciju: podaci, status i "Odobri" (samo administrator, samo dok je na čekanju). */
export default {
  name: "FinanceRefundPanel",
  inject: { shell: "reportShell" },
  props: {
    refund: { type: Object, required: true },
    restaurantId: { type: [Number, String], default: null },
    currency: { type: String, default: "KM" },
  },
  data: () => ({ saving: false, error: "" }),
  computed: {
    canApprove() {
      return this.shell.isAdmin && this.refund.status === "pending";
    },
    tone() {
      return TONES[this.refund.status] || "";
    },
    statusText() {
      const meta = REFUND_STATUS_META[this.refund.status];
      return meta ? this.$t(meta.labelKey) : this.refund.status;
    },
    methodText() {
      const key = `finance_shell.method.${this.refund.method}`;
      return this.$te(key) ? this.$t(key) : this.refund.method;
    },
  },
  methods: {
    money(value) {
      return formatMoney(Number(value) || 0, this.currency);
    },
    openOrder() {
      this.shell.openPanel({
        key: `order-${this.refund.orderId}`,
        title: this.$t("finance_shell.order_title", { id: this.refund.orderId }),
        component: OrderPanel,
        props: { orderId: Number(this.refund.orderId), restaurantId: this.restaurantId, currency: this.currency },
      });
    },
    async approve() {
      this.saving = true;
      this.error = "";
      try {
        await restaurantFinanceService.approveRefund(this.restaurantId, this.refund.id);
        this.shell.showToast(this.$t("finance_shell.refund.approved"));
        this.shell.closePanel();
        this.shell.reload();
      } catch (error) {
        this.error = (error && error.response && error.response.data && error.response.data.message) || this.$t("finance_shell.error_title");
      } finally {
        this.saving = false;
      }
    },
  },
};
</script>
